'use client';

import React from 'react';
import classNames from 'classnames';
import { ActiveExperiments } from '$util/abTest/experiments';
import { useActiveExperiment } from '$util/abTest';

import styles from './index.module.scss';

export interface CertifiedBadgeProps extends React.ComponentPropsWithoutRef<'div'> {
  readonly text?: string;
  readonly theme?: number;
}

export function CertifiedBadge({
  className,
  text = 'CERTIFIED GARAGE',
  theme = 1,
  ...props
}: CertifiedBadgeProps): JSX.Element {
  const isMechanicGaragesHeroUspUKB = useActiveExperiment(ActiveExperiments.MechanicGaragesHeroUspUK, 'B');

  return (
    <div className={classNames(styles.badge, className, theme === 2 && styles.theme2)} {...props}>
      <span className={styles.badgePrefix}>
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="17" viewBox="0 0 12 17" fill="none">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0.686362 5.49473L0.758383 7.66439L2.91023 7.59296L4.91054 3.5145C5.50839 2.29878 6.70252 1.51688 8.02811 1.47288L11.6274 1.35341L11.4392 1.02335L11.4388 1.02275C11.3232 0.81975 11.203 0.60901 11.083 0.398857L7.99586 0.501332C6.32765 0.556707 4.8251 1.54223 4.0737 3.07303L2.32382 6.6398L1.66494 6.66167L1.62517 5.46357L0.686362 5.49473ZM3.09725 14.6043L2.14105 14.1113L1.99991 10.0314L1.49681 9.07479L2.91214 9.0278L3.09725 14.6043ZM4.48407 14.9044L4.28701 8.96791L11.977 8.71265L12.0092 9.6842L5.25735 9.90832L5.42217 14.8733L4.48407 14.9044ZM5.9524 4.23123L4.3274 7.54288L11.9305 7.31324L11.8982 6.34099L5.88162 6.52435L6.78995 4.67267C7.06446 4.11326 7.61441 3.75302 8.22485 3.73276L11.807 3.61385L11.7747 2.6423L8.1926 2.76121C7.24026 2.79283 6.38186 3.35598 5.9524 4.23123Z"
            fill="white"
          />
        </svg>
      </span>
      <span className={styles.badgeText}>{isMechanicGaragesHeroUspUKB ? 'Fixter Rates' : text}</span>
    </div>
  );
}

CertifiedBadge.displayName = 'CertifiedBadge';
